import "moment/dist/locale/en-gb";
import "moment/dist/locale/es";

// @mui
import { caES, enUS, esES } from "@mui/material/locale";
import { useQueryClient } from "@tanstack/react-query";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { S3_URL } from "src/config";

// ----------------------------------------------------------------------

export type LangType = {
	label: string;
	value: string;
	calendar: string;
	systemValue: any;
	icon: string;
};

const LANGS: LangType[] = [
	{
		label: "spanish",
		value: "es_ES",
		calendar: "es",
		systemValue: esES,
		icon: `${S3_URL}/flags/es.png`
	},
	{
		label: "catalan",
		value: "cat",
		calendar: "cat",
		systemValue: caES,
		icon: `${S3_URL}/flags/cat.png`
	},
	{
		label: "english",
		value: "en",
		calendar: "en",
		systemValue: enUS,
		icon: `${S3_URL}/flags/gb.png`
	}
];

export default function useLocales() {
	const { i18n, t: translate } = useTranslation();
	const langStorage = localStorage.getItem("i18nextLng");
	const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0];

	moment.locale(currentLang.value === "es_ES" || currentLang.value === "cat" ? "es_ES" : "en");
	const queryClient = useQueryClient();

	const handleChangeLanguage = (newlang: string) => {
		queryClient.setQueryData(["user"], (prev: any) => ({ ...prev, language: newlang }));
		moment.locale(newlang === "es_ES" || newlang === "cat" ? "es_ES" : "en");
		i18n.changeLanguage(newlang);
	};

	return {
		onChangeLang: handleChangeLanguage,
		translate,
		currentLang,
		allLang: LANGS
	};
}
